import Vuex from 'vuex';
import axios from 'axios';
import config from '../config';
export default () => {
    return new Vuex.Store({
        state: {
            isPhone: false,
            config: {},
            menus: [],
            menuName: '',
            banner: '',
        },
        mutations: {},
        actions: {
            // 导航
            getConfig(context, payload){
                axios.get(config.config, {
                    params: {
                        lang: localStorage.getItem('locale')
                    }
                })
                .then((result) => {
                    if (result.data.code == 100) {
                        context.state.config = result.data.data;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            // 详情图文
            getDetail(context, payload){
                return new Promise((resolve, reject) => {
                    axios.get(config.detail, {
                        params: {
                            lang: localStorage.getItem('locale'),
                            ...payload
                        }
                    })
                        .then((result) => {
                            if (result.data.code == 100) {
                                context.state.menus = result.data.data.menus;
                                context.state.banner = result.data.data.banner;
                                resolve(result.data.data);
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                })
            },
            // 列表
            getList(context, payload){
                return new Promise((resolve, reject) => {
                    axios.get(config.list, {
                        params: {
                            lang: localStorage.getItem('locale'),
                            ...payload
                        }
                    })
                        .then((result) => {
                            if (result.data.code == 100) {
                                context.state.menus = result.data.data.menus;
                                context.state.banner = result.data.data.banner;
                                resolve(result.data.data);
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                });
            },
            // 照片列表
            getPhoto(context, payload){
                return new Promise((resolve, reject) => {
                    axios.get(config.photo, {
                        params: {
                            lang: localStorage.getItem('locale'),
                            ...payload
                        }
                    })
                        .then((result) => {
                            if (result.data.code == 100) {
                                context.state.menus = result.data.data.menus;
                                context.state.banner = result.data.data.banner;
                                resolve(result.data.data);
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                });
            },
            // 投诉报修
            getRepair(context, payload){
                return new Promise((resolve, reject) => {
                    axios.get(config.repair, {
                        params: {
                            lang: localStorage.getItem('locale'),
                            ...payload
                        }
                    })
                        .then((result) => {
                            if (result.data.code == 100) {
                                context.state.menus = result.data.data.menus;
                                context.state.banner = result.data.data.banner;
                                resolve(result.data.data);
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                });
            },
            // 投诉报修
            getRepairDetail(context, payload){
                return new Promise((resolve, reject) => {
                    axios.get(config.repairDetail, {
                        params: {
                            lang: localStorage.getItem('locale'),
                            ...payload
                        }
                    })
                        .then((result) => {
                            if (result.data.code == 100) {
                                context.state.menus = result.data.data.menus;
                                context.state.banner = result.data.data.banner;
                                resolve(result.data.data);
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                });
            },
            // 联系方式
            getContact(context, payload){
                return new Promise((resolve, reject) => {
                    axios.get(config.contact, {
                        params: {
                            lang: localStorage.getItem('locale'),
                            ...payload
                        }
                    })
                        .then((result) => {
                            if (result.data.code == 100) {
                                context.state.menus = result.data.data.menus;
                                context.state.banner = result.data.data.banner;
                                resolve(result.data.data);
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                });
            },
            // 联系方式
            getMessage(context, payload){
                return new Promise((resolve, reject) => {
                    axios.get(config.message, {
                        params: {
                            lang: localStorage.getItem('locale'),
                            ...payload
                        }
                    })
                        .then((result) => {
                            if (result.data.code == 100) {
                                context.state.menus = result.data.data.menus;
                                context.state.banner = result.data.data.banner;
                                resolve(result.data.data);
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                });
            },
            // 留言
            upMessage(context, payload){
                return new Promise((resolve, reject) => {
                    axios.get(config.upMessage, {
                        params: {
                            ...payload
                        }
                    })
                        .then((result) => {
                            if (result.data.code == 100) {
                                resolve();
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                });
            },
        }
    })
}